(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-full"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function apply(video, reduce) {
      if (reduce) {
        video.pause();
        try { video.currentTime = 0; } catch (e) {}
      } else {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    }
    function bind() {
      var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      document.querySelectorAll('[data-cz-hero-video]').forEach(function (video) {
        if (video.dataset.czMotionBound) return;
        video.dataset.czMotionBound = '1';
        apply(video, !!(mq && mq.matches));
        if (!mq) return;
        var onChange = function () { apply(video, mq.matches); };
        if (mq.addEventListener) mq.addEventListener('change', onChange);
        else if (mq.addListener) mq.addListener(onChange);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
    else bind();
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function czProductBind(root) {
    if (root.dataset.czBound) return;
    root.dataset.czBound = '1';

    var mainImg = root.querySelector('.cz-gal .cz-main img');
    var thumbs = root.querySelectorAll('[data-cz-thumb]');
    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        if (mainImg) {
          mainImg.src = btn.dataset.src;
          if (btn.dataset.srcset) mainImg.srcset = btn.dataset.srcset;
          mainImg.alt = btn.dataset.alt + ' — ' + btn.getAttribute('aria-label').toLowerCase();
        }
        thumbs.forEach(function (b, j) { b.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
      });
    });

    var qtyInput = root.querySelector('[data-cz-qty-input]');
    var qtyValue = root.querySelector('[data-cz-qty-value]');
    function setQty(d) {
      var q = Math.max(1, Math.min(10, (parseInt(qtyInput.value, 10) || 1) + d));
      qtyInput.value = q;
      if (qtyValue) qtyValue.textContent = q;
    }
    var dec = root.querySelector('[data-cz-qty-dec]');
    var inc = root.querySelector('[data-cz-qty-inc]');
    if (dec && qtyInput) dec.addEventListener('click', function () { setQty(-1); });
    if (inc && qtyInput) inc.addEventListener('click', function () { setQty(1); });

    if (window.czVariantPicker && typeof window.czVariantPicker.init === 'function') {
      window.czVariantPicker.init(root);
    }
  }
  function czProductBindAll() {
    document.querySelectorAll('[data-cz-product]').forEach(czProductBind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', czProductBindAll);
  } else {
    czProductBindAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-cz-product]').forEach(czProductBind);
  });

  } catch(e) { console.error(e); }
})();
})();
